import type {
  EstimatesRow,
  EstimateTreeColumns,
  EstimateTreeNode,
} from '../types'

/**
 * Flattens a nested estimate tree into a linear list of rows with hierarchical numbering.
 */
const flattenEstimateNodes = (
  nodes: EstimateTreeNode[],
  parentNumber = ''
): EstimatesRow[] => {
  return nodes.flatMap((node, index) => {
    const number = `${parentNumber}${index + 1}.`
    const { title, estimates, children = [] } = node

    const current: EstimatesRow = {
      number,
      title,
      estimates,
    }

    return [current, ...flattenEstimateNodes(children, number)]
  })
}

export const normalizeEstimateData = (estimates: EstimateTreeColumns) => {
  return estimates.flatMap((group) => flattenEstimateNodes(group))
}
